// The worded odds for a match, as the spotlight and the team card show them: 300 sim battles on the worker pool, on the
// match's map, through the calibrated fit (with the champion's incumbency edge). l / r are spotlight sides
// ({ key, label, bright, units }); map is the bracket's "NN) Name".
import { runBattlesParallel, ODDS_RUNS } from '../../lib/parallelSim.js';
import { oddsWords } from '../../lib/oddsWords.js';
import { tilesForMap } from '../../lib/fftPath.js';
import simCalibration from '../../data/simCalibration.json';
import battleConfig from '../../data/battleConfig.json';
import mapTerrain from '../../data/mapTerrain.json';
import mapTiles from '../../data/mapTiles.json';

const MAP_RE = /^\s*(\d+)\)\s*(.*)$/;

export async function matchOdds(l, r, map, gameData) {
  const mm = MAP_RE.exec(map || '');
  const terrain = (mm && mapTerrain.byName && mapTerrain.byName[mm[2].trim()]) || (mm && mapTerrain.maps ? mapTerrain.maps[mm[1]] : null) || null;
  const res = await runBattlesParallel(l.units, r.units, { ...battleConfig, terrain, tiles: tilesForMap(map, mapTiles) }, { runs: ODDS_RUNS, data: gameData });
  const champSide = l.key === 'champion' ? 'A' : r.key === 'champion' ? 'B' : null;
  const w = oddsWords(res, simCalibration, { champSide }), favL = w.fav === 'A';
  return { word: w.word, fav: favL ? l.label : r.label, favBright: favL ? l.bright : r.bright, pct: Math.round(100 * w.p), raw: Math.round(100 * w.raw), n: res.n, pA: favL ? w.p : 1 - w.p, rawL: Math.round(100 * (favL ? w.raw : 1 - w.raw)) };
}
